import React, { Component } from 'react';
import {IssueStyle} from './Style'

export default class IssueIndex extends Component {
	
	page_width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	max_spreads_on_screen = 6

	constructor(props){
		super(props);
		this.state = {
			page: 0,
		}
	}

	componentWillMount(){

	}

	nextPage(){
		const {page} = this.state;
		const {spreadCountOnScreen} = this

		// THIS IS WRONG

		if(page + 1 < spreadCountOnScreen)
			this.setState({page: page + 1});
	}

	prevPage(){
		const {page} = this.state;
		
		if(page > 0)
			this.setState({page: page-1});
	}	

	shouldComponentUpdate(nextProps, nextState){
		
		const {spreadIndex: prevSpreadIndex} = this.props;
		const {spreadIndex: newSpreadIndex} = nextProps;
		const {page: newPage} = nextState;
		const {page: prevPage} = this.state;

		if(newPage !== prevPage)
			return true;

		if(prevSpreadIndex !== newSpreadIndex)
			return true;

		return false;
	}

   render() {
		const {issueIndexHeight, bottomMenuHeight} = IssueStyle
		const {spreads, issue, spreadIndex} = this.props;
		const {page} = this.state;
		const {thumbnailSize} = issue;
		const wrapperStyle = {
			height: issueIndexHeight,
			bottom: bottomMenuHeight
		}

		const {page_width, max_spreads_on_screen} = this;
		const spreadCountOnScreen = Math.min(page_width / (thumbnailSize.width*2), max_spreads_on_screen);
		const indexStart = page * spreadCountOnScreen;
		const indexEnd = indexStart + spreadCountOnScreen <= spreads.length ? indexStart + spreadCountOnScreen : spreads.length;
		const imageStyle = {
			width: thumbnailSize.width,
			height: thumbnailSize.height
		}

		console.log({page, indexStart, indexEnd, spreadCountOnScreen})
		
		this.spreadCountOnScreen = spreadCountOnScreen;

      return (
         <div className={"issueIndex"} style={wrapperStyle}>
				<button className={'issueControls left'} onClick={this.prevPage.bind(this)} >&lt;</button>
				<button className={'issueControls right'} onClick={this.nextPage.bind(this)} >&gt;</button>
				{spreads.map((spread, si) => {
					return si >= indexStart && si < indexEnd ? (
						<div key={`si-${si}`} className={spreadIndex === si ? 'current' : null} onClick={() => this.props.onChangeSpreadIndex(si) }>
							{spread.map((page, pi) => {
								return <img style={imageStyle} key={`issue-index-th-${pi}`} src={page.thumbnail} alt={page.image} />
							})}
						</div>
					) : null
				})}
			</div>
      );
   }
}
   